// extracted by mini-css-extract-plugin
module.exports = {"HeaderHeight":"110px","AnnouncementHeight":"40px","SidebarWidth":"330px","element_type":"src-modules-element-components-Properties-ElementProperties---element_type---1k9KU"};